import { useMemo } from 'react';
import deepmerge from 'deepmerge';
import Highcharts from 'highcharts';

interface UseChartSettingsParams {
  series: any;
  settings: Record<string, any>;
  customSettings?: Record<string, any>;
}

export const useChartSettings = ({
  series,
  settings,
  customSettings,
}: UseChartSettingsParams): Highcharts.Options => {
  return useMemo(() => {
    const settingsWithData = {
      ...settings,
      series: series.map((seriesData, index) => ({
        ...seriesData,
        ...(settings.series ? settings.series[index] : {}),
        ...(customSettings?.series ? customSettings.series[index] : {}),
      })),
    };

    if (!customSettings) {
      return settingsWithData;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { series: _series, ...restCustomSettings } = customSettings;

    return deepmerge(settingsWithData, restCustomSettings);
  }, [series, settings, customSettings]);
};
